// 简体中文语言包
export default {
  __meta: { code: 'zh-CN', label: '简体中文', short: '中' },

  // 通用
  common: {
    yes: '是',
    no: '否',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    submit: '提交',
    loading: '加载中…',
    retry: '重试',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    all: '全部',
    more: '更多',
    less: '收起',
    close: '关闭',
    edit: '编辑',
    delete: '删除',
    copy: '复制',
    share: '分享',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
    online: '在线',
    offline: '离线'
  },

  // 导航
  nav: {
    home: '首页',
    problems: '硬问题',
    teams: '团队',
    leaderboard: '排行榜',
    chain: '区块链',
    academy: '学院',
    videos: 'HP 黑客松',
    login: '登录',
    register: '注册',
    logout: '退出',
    profile: '我的',
    language: '语言'
  },

  // 首页
  home: {
    title: '用 AI 解决世界上最难的 {n} 个问题',
    subtitle: '从黎曼猜想到室温超导，从意识到本质到核聚变',
    desc: '每个小朋友都能用 AI 尝试解决，每个解答都获得{reward}奖励。',
    reward: '链上 HPW 积分',
    cta: '开始解题 →',
    ctaLeaderboard: '查看排行榜',
    statsProblems: '硬问题',
    statsSolved: '已提交解答',
    statsUsers: '解题者',
    statsRewards: 'HPW 已发放',
    categories: '{n} 大领域',
    categoriesDesc: '点击进入任一领域，看看人类还没解决的问题',
    viewAll: '全部问题 →',
    liveOnChain: '链上 {txs} 笔交易 · {blocks} 个区块'
  },

  // 问题列表
  problems: {
    title: '所有硬问题',
    subtitle: '{n} 个挑战，覆盖 8 个领域',
    searchPlaceholder: '搜索问题、标签、关键词…',
    filterCategory: '学科',
    filterStatus: '状态',
    statusAll: '全部',
    statusOpen: '未解',
    statusPartial: '部分解',
    statusSolved: '已解',
    difficulty: '难度',
    reward: '奖励',
    solutions: '解答',
    votes: '净投票',
    tags: '标签',
    year: '提出年份',
    proposer: '提出者',
    empty: '没找到匹配的问题'
  },

  // 问题详情
  problem: {
    back: '← 返回问题列表',
    info: '问题信息',
    kidExplain: '小朋友版解释',
    formalStatement: '严格陈述',
    whyHard: '为什么这么难',
    howToEarn: '怎么获得积分',
    earnSubmit: '提交任何解答：+{n} HPW',
    earnAi: 'AI 评分 ≥ {n}：每分 +{m} HPW',
    earnVote: '被点赞（每人每次）：+{n} HPW 给作者',
    earnFullSolve: '解难题：最高 {n} HPW',
    earnRule: '所有积分 5 秒自动上链，永久可查。',
    aiSolver: 'AI 助手解题',
    aiSolverDesc: '告诉 AI 你的想法或附加要求，AI 会按"科普 → 学术 → 思路"三层结构来解答这个问题。',
    aiUsingLLM: '调用真实 LLM',
    aiFallback: '启发式回退',
    userInputPlaceholder: '（可选）比如：用例子帮助理解？',
    runAi: '用 AI 解答',
    noSolution: '还没有解答，做第一个！',
    submitSolution: '提交解答',
    submittedBy: '由 {user} 提交',
    quality: 'AI 评分',
    selfTest: '我的解答',
    openChat: '打开 AI 助手',
    inputPlaceholder: '问 AI 一个具体问题…',
    continueChat: '继续对话 ({n} 条消息)',
    openAI: '💬 打开 AI 助手'
  },

  // 提交
  submit: {
    title: '我的解答',
    contentPlaceholder: '把你想说的写下来。至少 20 字。结构越好分越高。',
    tooShort: '解答内容太短（至少 20 字）',
    submitted: '提交成功！',
    submitFailed: '提交失败：{msg}'
  },

  // 排行榜
  leaderboard: {
    title: '排行榜',
    subtitle: '按链上 HPW 积分排序。每 5 秒自动结算到新区块。',
    solvers: '解题者',
    solutions: '解答总数',
    txOnChain: '链上交易',
    height: '链高度',
    rewardsPaid: '已发奖励',
    rank: '排名',
    score: '积分',
    badges: '徽章',
    badgesTitle: '{n} 阶挑战者徽章'
  },

  // 区块链
  chain: {
    title: '区块链浏览器',
    subtitle: '每笔积分交易都不可篡改地上链。点击区块查看详情。',
    height: '链高度（区块）',
    totalTxs: '总交易（笔）',
    totalSupply: '总供应（HPW）',
    valid: '有效',
    invalid: '无效',
    selectBlock: '点左侧区块查看交易明细',
    latestBlocks: '最新区块',
    latestTxs: '最新交易',
    txId: '交易 ID',
    type: '类型',
    to: '接收方',
    amount: '金额',
    time: '时间',
    empty: '暂无数据'
  },

  // 登录/注册
  auth: {
    title: '加入硬问题',
    subtitle: '注册一个账号，开始你的硬问题之旅',
    username: '用户名',
    usernameHint: '2-30 字符，字母数字下划线中文横线',
    password: '密码',
    passwordHint: '6-200 字符',
    bio: '简介（可选）',
    bioHint: '最多 200 字符',
    register: '注册',
    login: '登录',
    switchToLogin: '已有账号？登录',
    switchToRegister: '没有账号？注册',
    welcome: '注册即送 100 HPW',
    errUsername: '用户名长度需在 2-30 之间',
    errPassword: '密码长度需在 6-200 之间',
    errTaken: '用户名已被占用',
    errWrong: '用户名或密码错误'
  },

  // 协作 (v1.4.0)
  collab: {
    discussions: '讨论',
    roadmap: '路线图',
    teams: '团队',
    teamsSubtitle: '和志同道合的解题者组队，贡献汇聚、积分共享',
    teamsFor: '为这道问题组建的团队',
    teamsCount: '个团队',
    selectProblem: '选择一个问题',
    chooseProblem: '请选择问题',
    pickProblemFirst: '请先在上方选择一个问题',
    startDiscussion: '发起一个新讨论…',
    post: '发送',
    reply: '回复',
    replyPlaceholder: '写下你的回复…',
    upvote: '点赞',
    downvote: '点踩',
    edited: '已编辑',
    noDiscussions: '还没有讨论 — 来开个头吧！',
    loginRequired: '请先登录',
    loginToDiscuss: '登录后可以参与讨论',
    loginToContribute: '登录后可以贡献路线图条目',
    confirmDelete: '确定要删除吗？此操作不可撤销。',
    roadmapSubtitle: '记录这个问题的研究/突破时间线 — 提议、探索、进行中、突破、受阻、完成',
    roadmapTitlePlaceholder: '进展标题（例如 2026 Q3: 综述调研）',
    roadmapDescPlaceholder: '可选描述',
    addEntry: '添加条目',
    noRoadmap: '暂无路线图条目',
    createTeam: '创建团队',
    teamNamePlaceholder: '团队名称（同一问题下唯一）',
    teamDescPlaceholder: '团队介绍（可选）',
    create: '创建',
    noTeamsYet: '还没有团队',
    beFirstToCreate: '要不要创建第一个？',
    leader: '队长',
    member: '成员',
    members: '成员',
    joinTeam: '加入团队',
    confirmLeave: '确定要离开这个团队？',
    confirmDisband: '确定要解散这个团队？此操作不可撤销！',
    disband: '解散',
    leaveTeam: '离开',
    contributions: '成员贡献',
    noContributions: '还没有贡献记录',
    solutions: '解答数',
    score: '积分',
    teamNotFound: '团队不存在或已解散',
    backToTeams: '返回团队列表',
    youAreLeader: '你是队长',
    youAreMember: '你是成员'
  },

  // 404
  notFound: {
    title: '404 — 这页走丢了',
    desc: '你要找的页面不存在，或者还没有被收录到 HardProblems 的索引里。不如去看看 {n} 个硬问题？',
    home: '← 回到首页',
    browse: '浏览问题',
    rank: '排行榜'
  },

  // PWA
  pwa: {
    install: '把 HardProblems 安装到桌面，随时查看',
    installShort: '安装到桌面',
    update: '新版本已就绪',
    updateNow: '立即更新',
    offline: '当前离线 · 部分功能不可用'
  },

  // 学科
  categories: {
    mathematics: '数学',
    physics: '物理',
    chemistry: '化学',
    biology: '生命科学',
    cs: '计算机',
    philosophy: '哲学',
    engineering: '工程',
    social: '社会'
  },

  // Hardcoded strings extracted from JSX
  hardcoded: {

  },

  // Hardcoded strings extracted from JSX
  hardcoded: {
    hc_87285292: '🎖 挑战者勋章',
    hc_38149815: '📦 最新区块',
    hc_48616739: '暂无区块',
    hc_57878265: '📨 最新交易',
    hc_63698773: '交易 ID',
    hc_1714432: '类型',
    hc_76617209: '接收方',
    hc_86455028: '金额',
    hc_45733203: '时间',
    hc_4062857: '暂无交易',
    hc_15614928: '交易明细',
    hc_12461780: '无（创世区块）',
    hc_36065070: '加载中...',
    hc_39726153: '用户不存在',
    hc_65423691: '下一勋章:',
    hc_65829733: 'HPW 余额',
    hc_33844058: '解答数',
    hc_34880504: '链上交易',
    hc_64546944: '累计获得',
    hc_63635099: '🔑 区块链钱包地址',
    hc_92114295: '💬 解答',
    hc_12374108: '📨 链上记录',
    hc_38642490: '暂无链上交易',
    hc_39272624: '所有硬问题',
    hc_72504969: '链上',
    hc_76554194: '笔交易 ·',
    hc_13199282: '位解题者',
    hc_49455724: '解决',
    hc_15553251: '世界上最难的',
    hc_73115764: '个问题',
    hc_58891330: '从黎曼猜想到室温超导，从意识本质到核聚变。',
    hc_11135829: '链上 HPW 积分奖励',
    hc_14271420: '视频号搜',
    hc_93127099: '"HP 黑客松"',
    hc_95444243: '· 每天 1 分钟点燃好奇心 · 微信搜一搜关注',
    hc_48803929: 'Search "HP 黑客松" on WeChat · 1 min a day to spark curiosity',
    hc_4038150: '问题不存在',
    hc_1415707: '← 返回问题列表',
    hc_3109735: '🙋 我能怎么参与？',
    hc_24717615: '不需要你是专家。以下任何方式都能帮到这道问题：',
    hc_6216823: '问 AI',
    hc_49022408: '，或在',
    hc_72042925: '排行榜',
    hc_60372142: '💬 AI 助手 · 多轮对话',
    hc_98658150: '小朋友版',
    hc_11457022: '严格陈述',
    hc_53488: '为什么难',
    hc_24903028: '🌀 思考中…',
    hc_67511018: '基于 AI 的内容修改后再提交，会被标记为 "AI 辅助"',
    hc_74081354: '✍️ 提交你的解答',
    hc_8743312: '5 维评估',
    hc_79230102: '✅ 提交成功！',
    hc_9486386: '· 获得',
    hc_10506083: '区块链',
    hc_60763393: '🤝 想组队解答？',
    hc_817654: '问题团队页',
    hc_91839987: '📋 问题元信息',
    hc_7972472: '提出年份',
    hc_4585175: '提出者',
    hc_49772229: '难度',
    hc_6351505: '状态',
    hc_77609957: '基础奖励',
    hc_59943341: '💰 怎么获得积分？',
    hc_1469249: '· 提交任何解答：',
    hc_66284549: '· AI 评分 ≥ 60：',
    hc_29791639: '· 被点赞（每人每次）：',
    hc_97186354: '+5 HPW 给作者',
    hc_18280432: '· 解开难题：',
    hc_76767612: '所有积分 5 秒内自动上链，永久可查。',
    hc_55655280: '🌟 分享这道硬问题',
    hc_9145530: '✓ 优势：',
    hc_9755158: '⚠ 不足：',
    hc_78448776: '🤖 AI 辅助',
    hc_99426362: '💬 AI 助手',
    hc_40752456: 'AI 已经读过这道问题的所有上下文。开始问吧 ↓',
    hc_67183189: 'AI 正在思考…',
    hc_38124998: '发送',
    hc_34225746: '出了点问题',
    hc_29662853: '链高',
    hc_84566882: '区块 ·',
    hc_41149725: '交易',
  }
};
